import { ChartType } from '../types';
import { defaultNumberValidation, } from './config-types';
import { returnNotSupportedChartType } from './config-utils';
export const CHART_CUSTOMISATION_CONFIG = [
    {
        key: 'tooltip',
        type: 'section',
        label: 'Tooltip',
        layoutType: 'tab',
        chartTypesNotSupported: [],
        children: [
            {
                key: 'enabled',
                type: 'toggle',
                defaultValue: true,
                selectedValue: true,
                label: 'Show/Hide',
                chartTypesNotSupported: [],
            },
            {
                key: 'backgroundColor',
                type: 'colorpicker',
                label: 'Background color',
                chartTypesNotSupported: [],
            },
            {
                key: 'borderColor',
                type: 'colorpicker',
                label: 'Border color',
                chartTypesNotSupported: [],
            },
            {
                key: 'borderWidth',
                type: 'text',
                defaultValue: '1',
                label: 'Border width (px)',
                chartTypesNotSupported: [],
            },
            {
                key: 'opacity',
                type: 'text',
                defaultValue: '100',
                inputValidation: defaultNumberValidation,
                label: 'Opacity (%)',
                chartTypesNotSupported: [],
            },
            {
                key: 'label',
                type: 'section',
                label: 'Column name label',
                chartTypesNotSupported: [],
                children: [
                    {
                        key: 'color',
                        type: 'colorpicker',
                        label: 'Font color',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'fontSize',
                        type: 'text',
                        defaultValue: '12',
                        inputValidation: defaultNumberValidation,
                        label: 'Font size',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'boldFontWeight',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Bold',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'underlineTextDecoration',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Underline',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'italicFontStyle',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Italic',
                        chartTypesNotSupported: [],
                    },
                ],
            },
            {
                key: 'value',
                type: 'section',
                label: 'Values in tooltip',
                chartTypesNotSupported: [],
                children: [
                    {
                        key: 'color',
                        type: 'colorpicker',
                        label: 'Color',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'fontSize',
                        type: 'text',
                        defaultValue: '12',
                        inputValidation: defaultNumberValidation,
                        label: 'Size',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'boldFontWeight',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Bold',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'underlineTextDecoration',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Underline',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'italicFontStyle',
                        type: 'checkbox',
                        defaultValue: false,
                        label: 'Italic',
                        chartTypesNotSupported: [],
                    },
                ],
            },
        ],
    },
    {
        key: 'regression',
        type: 'section',
        layoutType: 'tab',
        label: 'Regression line',
        chartTypesNotSupported: [
            ChartType.Pie,
            ChartType.Waterfall,
            ChartType.Heatmap,
            ChartType.Treemap,
            ChartType.Funnel,
        ],
        children: [
            {
                key: 'color',
                type: 'colorpicker',
                label: 'Color',
                chartTypesNotSupported: [],
            },
            {
                key: 'lineWidth',
                type: 'text',
                defaultValue: '2',
                inputValidation: defaultNumberValidation,
                label: 'Line width (px)',
                chartTypesNotSupported: [],
            },
            {
                key: 'dashStyle',
                type: 'dropdown',
                values: ['Solid', 'Dot', 'Dash'],
                defaultValue: 'Solid',
                label: 'Dash style',
                chartTypesNotSupported: [],
            },
        ],
    },
    {
        key: 'gridlines',
        type: 'section',
        label: 'Gridlines',
        layoutType: 'tab',
        chartTypesNotSupported: [
            ChartType.Heatmap,
            ChartType.Treemap,
            ChartType.Funnel,
            ChartType.Pie,
        ],
        children: [
            {
                key: 'xAxis',
                type: 'section',
                label: 'X-axis gridlines',
                chartTypesNotSupported: [],
                children: [
                    {
                        key: 'gridLineColor',
                        type: 'colorpicker',
                        label: 'Color',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'gridLineWidth',
                        type: 'text',
                        defaultValue: '2',
                        inputValidation: defaultNumberValidation,
                        label: 'Line width (px)',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'gridLineDashStyle',
                        type: 'dropdown',
                        values: ['Dash', 'Dot', 'Solid'],
                        defaultValue: 'Solid',
                        label: 'Line style',
                        chartTypesNotSupported: [],
                    },
                ],
            },
            {
                key: 'yAxis',
                type: 'section',
                label: 'Y-axis gridlines',
                chartTypesNotSupported: [],
                children: [
                    {
                        key: 'gridLineColor',
                        type: 'colorpicker',
                        label: 'Color',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'gridLineColor',
                        type: 'tecolorpickerxt',
                        defaultValue: '',
                        label: 'Color',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'gridLineWidth',
                        type: 'text',
                        defaultValue: '2',
                        inputValidation: defaultNumberValidation,
                        label: 'Line width (px)',
                        chartTypesNotSupported: [],
                    },
                    {
                        key: 'gridLineDashStyle',
                        type: 'dropdown',
                        values: ['Dash', 'Dot', 'Solid'],
                        defaultValue: 'Solid',
                        label: 'Line style',
                        chartTypesNotSupported: [],
                    },
                ],
            },
        ],
    },
    {
        key: 'answerLevelSettings',
        type: 'section',
        label: 'Other settings',
        layoutType: 'tab',
        chartTypesNotSupported: [],
        children: [
            {
                key: 'backgroundColor',
                type: 'colorpicker',
                label: 'Chart background color',
                chartTypesNotSupported: [],
            },
            {
                key: 'plotBackgroundColor',
                type: 'colorpicker',
                label: 'Background color for plotted area',
                chartTypesNotSupported: [],
            },
            {
                key: 'plotBackgroundImage',
                type: 'text',
                label: 'Background image URL for plotted area (png file)',
                chartTypesNotSupported: [],
            },
            {
                key: 'width',
                type: 'text',
                label: 'Bar width (px)',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Bar,
                        ChartType.StackedBar,
                    ]),
                ],
            },
            {
                key: 'width',
                type: 'text',
                label: 'Column width (px)',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Column,
                        ChartType.StackedColumn,
                        ChartType.LineColumn,
                        ChartType.LineStackedColumn,
                        ChartType.Waterfall,
                    ]),
                ],
            },
            {
                key: 'padding',
                type: 'text',
                label: 'Padding between bars (0-1 px)',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Bar,
                        ChartType.StackedBar,
                    ]),
                ],
            },
            {
                key: 'dashStyle',
                type: 'dropdown',
                defaultValue: 'Solid',
                values: ['Solid', 'Dash', 'Dot'],
                label: 'Line type',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Line,
                        ChartType.LineColumn,
                        ChartType.LineStackedColumn,
                        ChartType.Area,
                    ]),
                ],
            },
            {
                key: 'lineWidth',
                type: 'text',
                defaultValue: '',
                label: 'Line width (px)',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Line,
                        ChartType.LineColumn,
                        ChartType.LineStackedColumn,
                        ChartType.Area,
                    ]),
                ],
            },
            {
                key: 'markerType',
                type: 'dropdown',
                defaultValue: 'Circle',
                values: [
                    'Circle',
                    'Square',
                    'Diamond',
                    'Triangle',
                    'Triangle-down',
                ],
                label: 'Data marker type',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Line]),
                ],
            },
            {
                key: 'markerRadius',
                type: 'text',
                defaultValue: '',
                label: 'Data marker radius (px)',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Scatter]),
                ],
            },
            {
                key: 'padding',
                type: 'text',
                label: 'Padding between columns (0-1 px)',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Column,
                        ChartType.LineColumn,
                        ChartType.StackedColumn,
                        ChartType.LineStackedColumn,
                    ]),
                ],
            },
            {
                key: 'paddingCategories',
                type: 'text',
                label: 'Padding between categories (0-1 px)',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Bar,
                        ChartType.Column,
                        ChartType.StackedBar,
                        ChartType.StackedColumn,
                        ChartType.LineColumn,
                        ChartType.LineStackedColumn,
                    ]),
                ],
            },
            {
                key: 'borderColor',
                type: 'colorpicker',
                label: 'Border color',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Pie]),
                ],
            },
            {
                key: 'borderWidth',
                type: 'text',
                label: 'Border width (px)',
                defaultValue: '0',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([
                        ChartType.Pie,
                        ChartType.Heatmap,
                        ChartType.Treemap,
                    ]),
                ],
            },
            {
                key: 'connectingLines',
                type: 'toggle',
                defaultValue: false,
                label: 'Turn off connecting lines',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Waterfall]),
                ],
            },
            {
                key: 'lineColor',
                type: 'text',
                label: 'Line color',
                chartTypesNotSupported: [
                    ...returnNotSupportedChartType([ChartType.Pareto]),
                ],
            },
        ],
    },
];
//# sourceMappingURL=chart-advanced-customisation-config.js.map